import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import t from 'prop-types';

class Toast extends Component {
  constructor(props) {
    super(props);
    this.withCTA = props.withCTA;
    this.anchor = props.anchor;
    this.toast = props.forwardRef || React.createRef();
    this.handleClose = this.handleClose.bind(this);
  }

  componentDidMount() {
    if (this.withCTA && this.anchor === 'language-switch') {
      const langSwitcherLinks = document.querySelectorAll('.language-switcher .language-link');
      langSwitcherLinks.forEach((link) => {
        link.addEventListener('click', this.handleLanguageClick.bind(this));
      });
    }
  }

  /**
   * Close toast by a buttons click.
   */
  handleClose() {
    this.toggleToast();
  }

  /**
   * Handle language switcher links click whenever the Language Switcher is on the page.
   * @param e
   */
  handleLanguageClick(e) {
    const languageToast = this.toast.current;
    if (languageToast.dataset.rsToastAnchor === 'language-switch' && !languageToast.classList.contains('toast--active')) {
      e.preventDefault();
      this.toggleToast();
    }
  }

  /**
   * Toggle toast visibility.
   *
   * @param {Element} toast
   *  Toast element in DOM.
   */
  toggleToast() {
    const { classList } = this.toast.current;
    const toastState = {
      active: 'toast--active',
      closed: 'closable--closed',
    };

    if (classList.contains(toastState.active)) {
      classList.remove(toastState.active);
      classList.add(toastState.closed);
    } else {
      classList.add(toastState.active);
      classList.remove(toastState.closed);
    }
  }

  render() {
    const {
      intl, message, anchor, withCTA, fillColor = 'fill--off-white-alpha-50',
    } = this.props;
    const attrID = { [`data-rs-toast-${anchor}`]: true };

    return (
      <div
        className="toast bg-variant-brand-secondary"
        data-rs-toast-anchor={anchor}
        data-rs-toast={anchor}
        ref={this.toast}
        {...attrID}
      >
        <p className="toast__message">{message}</p>
        <button
          type="button"
          className="button--icon-only"
          aria-label={intl.formatMessage({ id: 'Close' })}
          data-rs-closable={`data-rs-toast-${anchor}`}
          onClick={this.handleClose}
        >
          <span className={`icon ${fillColor}`}>
            <svg>
              <use
                xlinkHref="/themes/custom/bluex/dist/assets/image/icons.svg#close"
              />
            </svg>
          </span>
        </button>
        {
          withCTA && (
          <div className="toast__cta">
            <button
              type="button"
              id="toast-cta-cancel"
              className="toast__cta button button--s button--white"
              onClick={this.handleClose}
            >
              {intl.formatMessage({ id: 'Toast.Cta.Cancel' })}
            </button>
            <a
              href="#!"
              id="toast-cta-continue"
              className="toast__cta ml-xs button button--s button--filled button--off-white"
            >
              {intl.formatMessage({ id: 'Toast.Cta.Proceed' })}
            </a>
          </div>
          )
        }
      </div>
    );
  }
}

Toast.propTypes = {
  intl: t.shape(injectIntl),
  message: t.oneOfType([
    t.string,
    t.shape({}),
  ]).isRequired,
  anchor: t.string.isRequired,
  withCTA: t.bool,
  fillColor: t.string,
  forwardRef: t.shape({ current: t.instanceOf(React.Component) }),
};

Toast.defaultProps = {
  withCTA: false,
  intl: injectIntl,
  fillColor: 'fill--off-white-alpha-50',
  forwardRef: React.createRef(),
};

export default injectIntl(withRouter(Toast));
